import request from '@/api/request'

/** AdminAuthenticationController */
export function adminLogin(payload: { username: string; password: string }) {
  return request.post<{ status: number; msg: string; token?: string; username?: string }>(
    '/api/admin/auth/login',
    payload
  )
}
